module.exports = __webpack_public_path__ + "img/commandcenter_parked.43a3ea03.svg";